// extracted by mini-css-extract-plugin
export default {"banner":"banner-info_banner__3H5tM","iconWrapper":"banner-info_iconWrapper__dTVh3","text":"banner-info_text__aqW1x"};